import React, { useState } from 'react';
import { toast } from 'react-toastify';

import { createFollowUp } from '../../api/Followup';
import { Followup } from '../../types/FollowUp';
import '../../css/modal.css';

interface CreateFollowupModalProps {
  queryId: number;
  onClose: () => void;
}

const CreateFollowupModal: React.FC<CreateFollowupModalProps> = ({ queryId, onClose }) => {
  const [formData, setFormData] = useState<Followup>({
    queryId: queryId,
    date: '',
    time: '',
    description: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    if (!formData.date) {
      toast.error('Please select a follow-up date.');
      return false;
    }
    if (!formData.time) {
      toast.error('Please enter the follow-up time.');
      return false;
    }
    if (!formData.description.trim()) {
      toast.error('Please enter a description.');
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      await createFollowUp({ ...formData, queryId });
      toast.success('Follow-up created successfully!');
      onClose();
    } catch (error) {
      toast.error('Failed to create follow-up.');
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal">
        <h2>Add Followup</h2>

        <label>
          Followup Date<span className="required">*</span>
        </label>
        <input
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
        />

        <label>
          Followup Time<span className="required">*</span>
        </label>
        <input
          type="time"
          name="time"
          value={formData.time}
          onChange={handleChange}
        />

        <label>
          Notes<span className="required">*</span>
        </label>
        <textarea
          name="description"
          rows={3}
          placeholder="add reason for the followup"
          value={formData.description}
          onChange={handleChange}
        />

        <div className="modal-actions">
          <button onClick={handleSubmit}>Save</button>
          <button onClick={onClose} className="secondary">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default CreateFollowupModal;
